import { BehaviorSubject } from 'rxjs';
import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class MyCommonService {
  isBrowser: boolean;
  access_token: any = new BehaviorSubject<any>("");
  constructor(@Inject(PLATFORM_ID) private platformId: Object) {
    this.isBrowser = isPlatformBrowser(this.platformId);
    //this.isBrowser = !this.isBrowser;
    //this.isBrowser = false;
  }

}
